import { call, put, takeEvery, all } from "redux-saga/effects";
import * as types from "./types";

// import { apiSuccess, apiFailure } from "./actions";
import {
  fetchCallDetailService,
  fetchCallLogsDetailsService,
  fetchCallLogsExtensionService,
  fetchCallLogsService,
  fetchCallStatsService,
  fetchCustomerInfoService,
  fetchIvrMenusService,
  fetchPostCallCustomer,
  // fetchQueueCallsService,
  fetchQueueTransferCallsService,
  fetchSyncExtensionsService,
  fetchSyncIvrMenusService,
  fetchTotalCountsQueueCallsService,
  updateCallLogService,
  updateTransferCallLogService,
} from "src/services";
import {
  fetchCallDetailFailure,
  fetchCallDetailRequest,
  fetchCallDetailSuccess,
  fetchCallLogsDetailFailure,
  fetchCallLogsDetailRequest,
  fetchCallLogsDetailSuccess,
  fetchCallLogsFailure,
  fetchCallLogsGetExtensionFailure,
  fetchCallLogsGetExtensionRequest,
  fetchCallLogsGetExtensionSuccess,
  fetchCallLogsRequest,
  fetchCallLogsSuccess,
  fetchCallStatsFailure,
  fetchCallStatsRequest,
  fetchCallStatsSuccess,
  fetchCustomerInfoFailure,
  fetchCustomerInfoRequest,
  fetchCustomerInfoSuccess,
  fetchIvrMenusFailure,
  fetchIvrMenusRequest,
  fetchIvrMenusSuccess,
  fetchQueueCallsFailure,
  fetchQueueCallsRequest,
  fetchQueueCallsSuccess,
  fetchTotalCountQueueCallsFailure,
  fetchTotalCountQueueCallsRequest,
  fetchTotalCountQueueCallsSuccess,
  syncExtensionsFailure,
  syncExtensionsRequest,
  syncExtensionsSuccess,
  syncIvrMenusFailure,
  syncIvrMenusSuccess,
  updateCallFailure,
  updateCallRequest,
  updateCallSuccess,
} from "./slice";
import { CallLogsPayload } from "src/interfaces";

// ==============================
// Worker Sagas (perform API calls)
// ==============================

function* handleFetchCallLogs(action: {
  type: string;
  payload?: CallLogsPayload;
}) {
  try {
    const payload = action.payload ?? {};

    // Pass full payload — NOT only page
    yield put(fetchCallLogsRequest());

    // Send entire filter object to API
    const response = yield call(fetchCallLogsService, payload);

    yield put(fetchCallLogsSuccess(response.data));
  } catch (error: any) {
    yield put(fetchCallLogsFailure(error.message));
  }
}

function* handleFetchIvrMenus(action: { type: string; payload?: any }) {
  try {
    yield put(fetchIvrMenusRequest());
    const response = yield call(fetchIvrMenusService);
    yield put(fetchIvrMenusSuccess(response.data));
  } catch (error: any) {
    yield put(fetchIvrMenusFailure(error.message));
  }
}

// Worker Saga: Sync IVR Menus
function* handleSyncIvrMenus(action: { type: string; payload?: any }) {
  try {
    const response = yield call(fetchSyncIvrMenusService);
    yield put(syncIvrMenusSuccess(response.data));
  } catch (error: any) {
    yield put(syncIvrMenusFailure(error.message));
  }
}

// Worker Saga: Sync Extensions
function* handleSyncExtensions(action: { type: string; payload?: any }) {
  try {
    yield put(syncExtensionsRequest());
    const response = yield call(fetchSyncExtensionsService);
    yield put(syncExtensionsSuccess(response.data));
  } catch (error: any) {
    yield put(syncExtensionsFailure(error.message));
  }
}

function* handleFetchCustomerInfo(action: { type: string; payload: string }) {
  try {
    const phone = action.payload;

    yield put(fetchCustomerInfoRequest(phone));

    const response = yield call(fetchCustomerInfoService, phone);

    yield put(fetchCustomerInfoSuccess(response.data));
  } catch (error: any) {
    yield put(fetchCustomerInfoFailure(error.message));
  }
}

function* handleFetchPostCallCustomerInfo(action: { type: string; payload: string }) {
  try {
    const sessionId = action.payload;

    yield put(fetchCustomerInfoRequest(sessionId));

    const response = yield call(fetchPostCallCustomer, sessionId);
    yield put(fetchCustomerInfoSuccess(response));
  } catch (error: any) {
    yield put(fetchCustomerInfoFailure(error.message));
  }
}

function* handleFetchCallDetail(action: { type: string; payload: string }) {
  try {
    yield put(fetchCallDetailRequest());
    const response = yield call(fetchCallDetailService, action.payload);
    const payload = {
      status: response.success, // map success -> status
      message: response.message,
      call: response.call,
    };

    yield put(fetchCallDetailSuccess(payload));
  } catch (error: any) {
    yield put(fetchCallDetailFailure(error.message));
  }
}

function* handleUpdateCallLog(action: { type: string; payload: any }) {
  try {
    const { sessionId, body } = action.payload;

    yield put(updateCallRequest());

    const response = yield call(updateCallLogService, sessionId, body);
    const payload = {
      success: response.success, // map success -> status
      message: response.message,
      call: response.call,
    };
    yield put(updateCallSuccess(payload));
  } catch (error: any) {
    yield put(updateCallFailure(error.message));
  }
}

function* handleUpdateTransferCallLog(action: { type: string; payload: any }) {
  try {
    const { body } = action.payload;

    yield put(updateCallRequest());

    const response = yield call(updateTransferCallLogService, body);
    const payload = {
      success: response.success, // map success -> status
      message: response.message,
      call: response.call,
    };
    yield put(updateCallSuccess(payload));
  } catch (error: any) {
    yield put(updateCallFailure(error.message));
  }
}

// function* handleFetchQueueCalls(action: { type: string; payload?: any }) {
//   try {
//     yield put(fetchQueueCallsRequest()); // start loader

//     const response = yield call(fetchQueueCallsService, action.payload);
//     yield put(fetchQueueCallsSuccess(response)); // store success
//   } catch (error: any) {
//     yield put(fetchQueueCallsFailure(error.message));
//   }
// }

function* handleFetchQueueTransferCalls(action: { type: string; payload?: any }) {
  try {
    yield put(fetchQueueCallsRequest()); // start loader

    const response = yield call(fetchQueueTransferCallsService, action.payload);
    yield put(fetchQueueCallsSuccess(response)); // store success
  } catch (error: any) {
    yield put(fetchQueueCallsFailure(error.message));
  }
}

function* handleFetchTotalCountQueueCalls() {
  try {
    yield put(fetchTotalCountQueueCallsRequest());

    const response = yield call(fetchTotalCountsQueueCallsService);
    yield put(fetchTotalCountQueueCallsSuccess(response));
  } catch (error: any) {
    yield put(fetchTotalCountQueueCallsFailure(error.message));
  }
}

function* handleFetchCallStats(action: { type: string; payload?: any }) {
  try {
    yield put(fetchCallStatsRequest()); // start loader

    const response = yield call(fetchCallStatsService);

    yield put(fetchCallStatsSuccess(response.data)); // store success
  } catch (error: any) {
    yield put(fetchCallStatsFailure(error.message));
  }
}

function* handleFetchCallLogsDetail(action: { type: string; payload?: any }) {
  try {
    yield put(fetchCallLogsDetailRequest());
    const { sessionId, page } = action.payload; // destructure
    const response = yield call(fetchCallLogsDetailsService, sessionId, page);
    yield put(fetchCallLogsDetailSuccess(response));
  } catch (error: any) {
    yield put(fetchCallLogsDetailFailure(error.message));
  }
}

function* handleFetchCallLogsGetExtension(action: {
  type: string;
  payload?: any;
}) {
  try {
    yield put(fetchCallLogsGetExtensionRequest());
    const response = yield call(fetchCallLogsExtensionService);
    yield put(fetchCallLogsGetExtensionSuccess(response));
  } catch (error: any) {
    yield put(fetchCallLogsGetExtensionFailure(error.message));
  }
}

export default function* callLogsSaga() {
  yield all([
    takeEvery(types.FETCH_CALL_LOGS, handleFetchCallLogs),
    takeEvery(types.FETCH_IVR_MENUS, handleFetchIvrMenus),
    takeEvery(types.SYNC_IVR_MENUS, handleSyncIvrMenus),
    takeEvery(types.SYNC_EXTENSIONS, handleSyncExtensions),
    takeEvery(types.FETCH_CUSTOMER_INFO, handleFetchCustomerInfo),
    takeEvery(types.FETCH_POST_CALL_CUSTOMER_INFO, handleFetchPostCallCustomerInfo),
    takeEvery(types.FETCH_CALL_DETAIL, handleFetchCallDetail),
    takeEvery(types.UPDATE_CALL_LOG, handleUpdateCallLog),
    takeEvery(types.UPDATE_TRANSFER_CALL_LOG, handleUpdateTransferCallLog),
    takeEvery(types.FETCH_TOTAL_COUNT_QUEUE__CALLS, handleFetchTotalCountQueueCalls),
    // takeEvery(types.FETCH_QUEUE_CALLS, handleFetchQueueCalls),
    takeEvery(types.FETCH_QUEUE_TRANSFER_CALLS, handleFetchQueueTransferCalls),
    takeEvery(types.FETCH_CALL_STATS, handleFetchCallStats),
    takeEvery(types.FETCH_CALL_LOGS_DETAILS, handleFetchCallLogsDetail),
    takeEvery(
      types.FETCH_CALL_LOGS_GET_EXTENSIONS,
      handleFetchCallLogsGetExtension
    ),
  ]);
}
